'use strict';

var axios = require('axios');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var axios__default = /*#__PURE__*/_interopDefault(axios);

// src/client.ts
var MessageStatus = /* @__PURE__ */ ((MessageStatus2) => {
  MessageStatus2["INFLIGHT"] = "INFLIGHT";
  MessageStatus2["DELIVERED"] = "DELIVERED";
  MessageStatus2["FAILED"] = "FAILED";
  return MessageStatus2;
})(MessageStatus || {});
var URLS = {
  testnet: "https://api-testnet.layerzero-scan.com",
  mainnet: "https://api-mainnet.layerzero-scan.com",
  sandbox: "https://api-sandbox.layerzero-scan.com"
};
var createClient = (env, options) => {
  const url = URLS[env];
  if (!url)
    throw new Error(`No endpoint for env ${env}`);
  const client = axios__default.default.create({
    baseURL: url
  });
  return {
    async getMessagesBySrcTxHash(srcTxHash) {
      if (!srcTxHash)
        throw new Error("srcTxHash must be provided");
      const { data } = await client.get(`/tx/${srcTxHash}`);
      return data;
    }
  };
};
function getMessagesBySrcTxHash(srcChainId, srcTxHash) {
  const env = getStage(srcChainId);
  return createClient(env).getMessagesBySrcTxHash(srcTxHash);
}
async function waitForMessageReceived(srcChainId, srcTxHash, pollInterval = 3e3) {
  const env = getStage(srcChainId);
  const client = createClient(env);
  while (true) {
    try {
      const { messages } = await client.getMessagesBySrcTxHash(srcTxHash);
      const message = messages[0];
      if (messages.length > 1) {
        return Promise.reject(new Error(`More than one message`));
      } else if ((message == null ? void 0 : message.status) === "FAILED" /* FAILED */) {
        return Promise.reject(new Error(`Message failed ${message.dstTxError}`));
      } else if ((message == null ? void 0 : message.status) === "DELIVERED" /* DELIVERED */) {
        return message;
      }
    } catch (e) {
    }
    await sleep(pollInterval);
  }
}
async function waitForAllMessagesReceived(srcChainId, srcTxHash, pollInterval = 3e3, numberOfMessages) {
  const env = getStage(srcChainId);
  const client = createClient(env);
  while (true) {
    try {
      const { messages } = await client.getMessagesBySrcTxHash(srcTxHash);
      if (messages.length > 0) {
        if (messages.every((m) => m.status === "DELIVERED" /* DELIVERED */)) {
          if (numberOfMessages === void 0 || numberOfMessages === messages.length) {
            return messages;
          }
        }
      }
    } catch (e) {
    }
    await sleep(pollInterval);
  }
}
function getStage(chainId) {
  if (chainId < 1e4)
    return "mainnet";
  if (chainId < 2e4)
    return "testnet";
  if (chainId < 3e4)
    return "sandbox";
  if (chainId < 4e4)
    return "mainnet";
  if (chainId < 5e4)
    return "testnet";
  if (chainId < 6e4)
    return "sandbox";
  throw new Error(`Unknown chainId ${chainId}`);
}
var sleep = (ms = 1e3) => new Promise((resolve) => setTimeout(resolve, ms));

exports.MessageStatus = MessageStatus;
exports.createClient = createClient;
exports.getMessagesBySrcTxHash = getMessagesBySrcTxHash;
exports.waitForAllMessagesReceived = waitForAllMessagesReceived;
exports.waitForMessageReceived = waitForMessageReceived;
//# sourceMappingURL=out.js.map
//# sourceMappingURL=client.cjs.map